/**
 * Returns a URL ready for <iframe>/<video> embedding from a public video URL.
 * Supports YouTube (watch/youtu.be/shorts/embed), Vimeo, and direct MP4/WebM/MOV.
 * Returns null when the URL is unrecognised.
 */
export function getEmbedUrl(url) {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  if (/\.(mp4|webm|mov)(\?|$)/i.test(url)) return url;
  return null;
}

export function isDirectVideoFile(url) {
  return !!url && /\.(mp4|webm|mov)(\?|$)/i.test(url);
}
